import { library,  } from '@fortawesome/fontawesome-svg-core'
//import { fab } from '@fortawesome/free-brands-svg-icons'
import { faTint } from '@fortawesome/free-solid-svg-icons'

library.add(faTint);
